import { Entity } from './entity.js';

export class DataStreamEntity extends Entity
{

}